import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AnimalToFarrowingTableItem, IAnimalToFarrowingTableItem } from 'shared/api/api';
import sokort_icon from 'shared/assets/src-assets/png/sokort_icon.png';
import { getDateString } from 'shared/helpers/date-helpers';
import { NaturalSortDates } from 'shared/helpers/natural-sort';
import {
	GetDashboardGetAnimalToFarrowingTable,
	GetDashboardGetNeedFarrowingTable,
} from 'shared/state/ducks/dashboard/operations';
import { localized, localizedInterpolation } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import SkioldTableGrid, {
	SkioldTableGrid as SkioldTableRef,
} from 'web/view/components/skiold-components/skiold-table/skiold-table-grid/skiold-table-grid';
import { ViewWeb } from 'web/view/components/utils/web-view';
import SowCard from 'web/view/pages/sow-card/sow-card';
import {
	GetAnimalToFarrowingTableDashboardPdf,
	GetMatingBatchWeekPdf,
} from 'web/web-helpers/pdf-helper/dashboard-pdf-helper.ts/dashboard-pdf-helper';
import { SkioldModal } from '../../skiold-components/skiold-modal/skiold-modal';
import { SkioldTouchableOpacity } from '../../skiold-components/skiold-touchable-opacity';
import { SowListConstants } from '../../stem-animal/animal-lists/table-constants';
import { Heading } from '../../utils/heading';
import { SkioldImage } from '../../utils/svg/skiold-image';
import {
	defaultSortingDashboardModals,
	getAnimalToFarrowingColorStyle,
	getWebAnimalColorStyleDashboard,
} from '../dashboard-helper';
import { DashboardModalHeader } from '../dashboard-modal-header';
import { ClipLoader } from 'react-spinners';
import './animals-to-farrowing-dashboard-table.scss';
import { TotalMatingTableItemType } from '../total-matings-dashboard-table/total-matings-dashboard-table';
import { TotalMatingPrintModal } from '../total-matings-dashboard-table/total-mating-print-modal';

interface PropsFromParent {
	batchId?: string;
	needFarrowing?: boolean;
	closeModal: () => void;
}

interface State {
	sowCardModal: boolean;
	stemAnimalId: string;
	data: IAnimalToFarrowingTableItem[];
	loading: boolean;
	showPrintModal: boolean;
}

const mapStateToProps = (state: WebAppState, props: PropsFromParent) => {
	return {
		matingBatch: state.matingBatches.entities.find(mb => mb.id === props.batchId),
		profile: state.profile.active,
	};
};

const mapDispatchToProps = (dispatch: Dispatch, props: PropsFromParent) => {
	return {
		GetDashboardGetAnimalToFarrowingTable: (siteId: string, batchId: string) =>
			props.needFarrowing
				? GetDashboardGetNeedFarrowingTable(siteId, batchId)
				: GetDashboardGetAnimalToFarrowingTable(siteId, batchId),
	};
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & PropsFromParent;

export class AnimalsToFarrowingsDashboardTable extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { sowCardModal: false, stemAnimalId: '', data: [], loading: true, showPrintModal: false };
	}
	public componentDidMount = () => {
		if (this.props.profile && this.props.profile.siteId && this.props.batchId) {
			this.props
				.GetDashboardGetAnimalToFarrowingTable(this.props.profile.siteId, this.props.batchId)
				.then(d => this.setState({ data: d, loading: false }));
		}
	};

	public render() {
		return (
			<ViewWeb className="animals-to-farrowing-dashboard-table">
				<Heading
					text={
						this.props.needFarrowing
							? localized('NeedFarrowingTable')
							: localized('AnimalsToFarrowingTable')
					}
				/>
				<DashboardModalHeader
					closeModal={this.props.closeModal}
					matingBatch={this.props.matingBatch}
					printData={this.openPrintModal}
				/>

				{this.state.loading ? (
					<ViewWeb className="spinner-container-active-dashboard">
						<ClipLoader color="#f2ac40" size={70} />
					</ViewWeb>
				) : (
					<ViewWeb className="dashboard-modal-table">
						<SkioldTableGrid
							sortHeaderId={defaultSortingDashboardModals}
							data={this.state.data}
							columns={this.generateColumns}
							ColumnExtensions={this.getColumnExtenstions}
							usesSummaryRow={true}
							ref={this.setTableRef}
							tableKey={'AnimalsToFarrowingDashboardTable'}
						/>
						<SkioldModal
							shouldCloseOnOverlayClick={true}
							padding="0"
							isOpen={this.state.sowCardModal}
							close={this.closeModal}
							justify-content="flex-end"
							max-width="calc(100% - 220px)"
						>
							<SowCard stemAnimalIdFromParent={this.state.stemAnimalId} close={this.closeModal} />
						</SkioldModal>
						<SkioldModal
							shouldCloseOnOverlayClick={true}
							padding="0"
							isOpen={this.state.showPrintModal}
							close={this.closeModal}
							minWidth="300px"
						>
							<TotalMatingPrintModal
								closeModal={this.closePrintModal}
								printElaboration={this.printData}
								printWeekList={this.printWeekList}
								batchNumber={this.props.matingBatch?.batchNumber}
							/>
						</SkioldModal>
					</ViewWeb>
				)}
			</ViewWeb>
		);
	}

	private printWeekList = async () => {
		if (this.SkioldTableRef && this.props.profile && this.props.profile.siteId) {
			let data: IAnimalToFarrowingTableItem[] = this.SkioldTableRef.GetSortedData();
			GetMatingBatchWeekPdf(
				data.map(
					a =>
						({
							animalNumber: a.animalNumber,
							breedRace: a.breedRace,
							litterNumber: a.litterNumber,
							matingDate: a.matingDate,
							pregnancyDays: a.pregnancyDays,
							expectedFarrowingDate: a.expectedFarrowingDate,
						} as TotalMatingTableItemType),
				),
				localizedInterpolation('weekBatchPdf', this.props.matingBatch?.batchNumber) + '.pdf',
				this.props.profile.siteId,
				Intl.DateTimeFormat().resolvedOptions().timeZone,
				this.props.profile.language,
				localizedInterpolation('weekBatchPdf', this.props.matingBatch?.batchNumber),
			);
		}
	};

	private printData = async () => {
		if (this.SkioldTableRef && this.props.profile && this.props.profile.siteId) {
			let data = this.SkioldTableRef.GetSortedData();
			GetAnimalToFarrowingTableDashboardPdf(
				data,
				this.props.needFarrowing ? 'NeedFarrowing.pdf' : 'AnimalsToFarrowing.pdf',
				this.props.profile.siteId,
				Intl.DateTimeFormat().resolvedOptions().timeZone,
				this.props.profile.language,
				this.props.needFarrowing,
			);
		}
	};
	public SkioldTableRef: SkioldTableRef | undefined;
	private setTableRef = (m: any) => (m ? (this.SkioldTableRef = m) : {});

	private getColumnExtenstions = [
		{
			columnName: 'sowCard',
			filteringEnabled: false,
			width: SowListConstants.iconWidth,
		},
		{
			columnName: 'pregnantDays',
			usesSummary: true,
			width: SowListConstants.pregnantDaysDashboardWidth,
		},
		{
			columnName: 'animalNr',
			width: SowListConstants.dateWidth,
		},
		{ columnName: 'breedRace', width: SowListConstants.animalNrWidth },
		{
			columnName: 'litter',
			width: SowListConstants.iDNumberWidth,
		},
		{
			columnName: 'avgPregnancyDays',
			usesSummary: true,
			width: SowListConstants.pregnantDaysDashboardWidth,
		},
		{
			columnName: 'expectedFarrowingDate',
			width: SowListConstants.treatmentExecutedDateWidth,
		},
	];
	private showSowCard = (stemAnimalId?: string) => {
		if (stemAnimalId) {
			this.setState({ sowCardModal: true, stemAnimalId: stemAnimalId });
		}
	};

	private closeModal = () => {
		this.setState({ stemAnimalId: '', sowCardModal: false });
	};

	private openPrintModal = () => {
		this.setState({ showPrintModal: true });
	};

	private closePrintModal = () => {
		this.setState({ showPrintModal: false });
	};

	private generateColumns = [
		{
			name: 'sowCard',
			title: ' ',
			Footer: localized('avg'),
			sortable: false,
			getCellValue: (item: AnimalToFarrowingTableItem) => (
				<SkioldTouchableOpacity itemFromParent={item.sowId} onPress={this.showSowCard}>
					<SkioldImage
						width={SowListConstants.iconSVGWidth}
						height={SowListConstants.iconSVGWidth}
						imageData={sokort_icon}
					/>
				</SkioldTouchableOpacity>
			),
		},
		{
			name: 'pregnantDays',
			title: localized('pregnantDays'),
			getCellValue: (item: AnimalToFarrowingTableItem) => item.pregnancyDays,
		},
		{
			name: 'animalNr',
			title: localized('animalNr'),
			className: getWebAnimalColorStyleDashboard,
			getCellValue: (item: AnimalToFarrowingTableItem) => item.animalNumber,
		},
		{
			name: 'breedRace',
			title: localized('Race'),
		},
		{
			name: 'litter',
			title: localized('Litters'),
			getCellValue: (item: AnimalToFarrowingTableItem) => item.litterNumber,
		},
		{
			name: 'avgPregnancyDays',
			title: <div className={'alignDivsCenter'}>{localized('AvgPregnantDaysPreviousBatch')}</div>,
			getCellValue: (item: AnimalToFarrowingTableItem) => item.avgPregnancyDays,
		},
		{
			name: 'expectedFarrowingDate',
			title: <div className={'alignDivsCenter'}>{localized('expectedFarrowingDashboard')}</div>,
			sortFunction: NaturalSortDates,
			className: getAnimalToFarrowingColorStyle,
			getCellValue: (item: AnimalToFarrowingTableItem) => getDateString(item.expectedFarrowingDate),
		},
	];
}

export default connect(mapStateToProps, mapDispatchToProps)(AnimalsToFarrowingsDashboardTable);
